import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import PaymentsIcon from "@mui/icons-material/Payments";
import ReceiptIcon from "@mui/icons-material/Receipt";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { handleLogout } from "./utils/utils";
import { getOrganizationSettings, getUser } from "./utils/storage";
import LogoOnly from "./components/logoOnly";


export default function Sidebar({ isOpen, onClose }) {
  const location = useLocation();
  let counter = 0;


  const [sidebarLinks, setSidebarLinks] = useState([
    {
      label: "Dashboard",
      icon: DashboardIcon,
      href: "/dashboard",
      description: "Overview & Analytics",
    },
    {
      label: "Wallets",
      icon: AccountBalanceWalletIcon,
      href: "/wallets",
      description: "Manage Accounts",
    },

    {
      label: "Settings",
      icon: SettingsIcon,
      href: "/settings",
      description: "App Configuration",
    },
    {
      label: "Profile",
      icon: PersonIcon,
      href: "/profile",
      description: "Account Settings",
    },
  ]);


  const user = getUser();

  const paymentsMenu = {
    label: "Payments",
    icon: PaymentsIcon,
    href: "/payment",
    description: "Send Money",
  };

  const liquidationMenu = {
    label: "Liquidation Request",
    icon: AccountBalanceWalletIcon,
    href: "/liquidation-request",
    description: "Liquidate funds",
  };

  const billMenu = {
    label: "Bills",
    icon: ReceiptIcon,
    href: "/bills",
    description: "Bill Payments",
  };

  const loanMenu = {
    label: "Loan Center",
    icon: AccountBalanceWalletIcon,
    href: "/loan-center",
    description: "Loan management",
  };

  const eproductMenu = {
    label: "eProducts",
    icon: PersonIcon,
    href: "/e-products",
    description: "eProducts",
  }

  const investmentMenu = {
    label: "Investments",
    icon: AccountBalanceWalletIcon,
    href: "/investments",
    description: "Investment management",
  };

  const transactionsMenu = {
    label: "Transactions",
    icon: SwapHorizIcon,
    href: "/transactions",
    description: "Payment History",
  };

  const cardMenu = {
    label: "Cards",
    icon: CreditCardIcon,
    href: "/cards",
    description: "Virtual Cards",
  };

  useEffect(() => {
    const {
      organization_subscribed_features,
      customized_app_displayable_menu_items,
    } = getOrganizationSettings();

    if (organization_subscribed_features) {
      let newMenus = [...sidebarLinks]; // clone array first ✅

      if (
        organization_subscribed_features["loan-mgt"] &&
        customized_app_displayable_menu_items["display-loan-menu"]
      ) {
        newMenus.splice(2, 0, loanMenu);
      }

      if (organization_subscribed_features["vtu-mgt"]) {
        newMenus.splice(3, 0, billMenu);
      }

      if (
        organization_subscribed_features["card-mgt"] &&
        customized_app_displayable_menu_items["display-virtual-card-menu"]
      ) {
        newMenus.splice(4, 0, cardMenu);
      }

      if (
        organization_subscribed_features["properties-mgt"] &&
        customized_app_displayable_menu_items["display-property-menu"]
      ) {
        newMenus.splice(5, 0, eproductMenu);
      }


      if (organization_subscribed_features['customers-mgt'] && (customized_app_displayable_menu_items["display-wallet-partial-liquidation-menu"] || customized_app_displayable_menu_items["display-wallet-full-liquidation-menu"])) {
        newMenus.splice(6, 0, liquidationMenu);
      }

      if (customized_app_displayable_menu_items["display-transaction-histories"]) {
        newMenus.splice(7, 0, transactionsMenu);
      }

      if (
        organization_subscribed_features["payments-manager"] &&
        customized_app_displayable_menu_items["display-bank-transfer-menu"]
      ) {
        newMenus.splice(8, 0, paymentsMenu);
      }

      if (
        organization_subscribed_features["investment-mgt"] &&
        customized_app_displayable_menu_items["display-investment-menu"]
      ) {
        newMenus.splice(9, 0, investmentMenu);
      }

      console.log(newMenus, "new menu things");


      setSidebarLinks(newMenus); // ✅ now React sees new array
    }
  }, []);


  return (
    <div
      className={`fixed inset-y-0 left-0 z-50 w-72 h-full bg-white/80 backdrop-blur-xl border-r border-white/20 shadow-large transform transition-all duration-300 ease-in-out ${isOpen ? "translate-x-0" : "-translate-x-full"
        } xl:relative xl:translate-x-0 xl:inset-0`}
    >
      <div className="flex flex-col h-full">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-100/50 flex-shrink-0">
          <div className="flex items-center space-x-3">
            <LogoOnly />
          </div>
          <IconButton
            onClick={onClose}
            className="xl:hidden text-gray-400 hover:text-gray-600 hover:bg-gray-100/50 rounded-xl transition-all duration-200"
          >
            <CloseIcon />
          </IconButton>
        </div>

        {/* Scrollable Menu */}
        <nav className="flex-1 overflow-y-auto px-4 py-6 space-y-1">
          {sidebarLinks.map((link) => {
            const selected = location.pathname === link.href;
            const IconComponent = link.icon;

            return (
              <Link
                key={link.label}
                to={link.href}
                onClick={onClose}
                className={`group relative flex items-center space-x-3 px-4 py-3 rounded-2xl transition-all duration-300 ${selected
                  ? "bg-gradient-to-r from-primary-50 to-primary-100 text-primary-700 border border-primary-200/50 shadow-soft"
                  : "text-gray-600 hover:bg-gray-50/80 hover:text-gray-900 hover:shadow-soft"
                  }`}
              >
                <div
                  className={`p-2 rounded-xl transition-all duration-300 ${selected
                    ? "bg-primary-100 text-primary-600"
                    : "bg-gray-100/50 text-gray-400 group-hover:bg-gray-200/50 group-hover:text-gray-600"
                    }`}
                >
                  <IconComponent className="text-xl" />
                </div>
                <div className="flex-1">
                  <span
                    className={`font-semibold transition-colors duration-300 ${selected
                      ? "text-primary-700"
                      : "text-gray-700 group-hover:text-gray-900"
                      }`}
                  >
                    {link.label}
                  </span>
                  <p
                    className={`text-xs transition-colors duration-300 ${selected
                      ? "text-primary-600"
                      : "text-gray-400 group-hover:text-gray-500"
                      }`}
                  >
                    {link.description}
                  </p>
                </div>
                {selected && (
                  <div className="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></div>
                )}
              </Link>
            );
          })}
        </nav>

        {/* Fixed Bottom */}
        <div className="p-4 border-t border-gray-100/50 bg-gradient-to-r from-gray-50/50 to-primary-50/30 flex-shrink-0">
          <div className="flex items-center space-x-3 p-3 rounded-2xl bg-white/50 backdrop-blur-sm border border-white/20 shadow-soft">
            <div className="relative">
              <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl flex items-center justify-center shadow-medium">
                <span className="text-white font-bold text-lg">
                  {user?.name?.[0] || user?.username?.[0] || "U"}
                </span>
              </div>
              <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-success-500 border-2 border-white rounded-full"></div>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-gray-900 truncate">
                {user?.name || user?.username || "User"}
              </p>
              <p className="text-xs text-gray-500 truncate">
                {user?.email || "user@example.com"}
              </p>
            </div>
            <div className="flex flex-col space-y-1">
              <IconButton
                size="small"
                className="text-gray-400 hover:text-gray-600 hover:bg-gray-100/50 rounded-xl transition-all duration-200"
              >
                <NotificationsIcon fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                onClick={handleLogout}
                className="text-gray-400 hover:text-danger-600 hover:bg-danger-50/50 rounded-xl transition-all duration-200"
              >
                <LogoutIcon fontSize="small" />
              </IconButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
